import React, { useEffect, useState, useContext, useRef, useLayoutEffect } from 'react';  
import { Navigate, Outlet, useLocation } from 'react-router-dom';  
import { LoginContext, OverlayContext } from './App';
import { Loading } from './Common';
import { useAutoLoad } from './hooks';
import { LoadState } from './enums.mjs';
import { resetLoginStates, setLoginStatesFromJson } from './util';

export const LoginCheck = ({onLoginStatusChanged, management}) => {
    const login = useContext(LoginContext);
    const overlay = useContext(OverlayContext);

    const [checkLoginTriggerInternal, setCheckLoginTriggerInternal] = useState(false);

    const loggedInRef = useRef(login.loggedIn);


    // EFFECTS:

    // useEffect(() => {
    //     // setLoadState(LoadState.LOADING);
    //     // console.log("login check state change");
// 
    //     // We do not want to check the login if login.checkingLogin is false
    //     if(login.checkingLogin) {
    //         console.log("setting");
    //         setCheckLoginTriggerInternal(!checkLoginTriggerInternal);
    //     }
    // }, [login.checkingLogin]);

    useEffect(() => {
        loggedInRef.current = login.loggedIn;
    }, [login.loggedIn])

    // We want to continuously check the login as e.g. changes in the mediation status (extracted in ConsumerApp) should be detected.
    // However, we do not want to unset all states only because a scheduled login check failed (unstable connection).
    // Therefore the UI logout will only be performed if the login check was triggered manually (e.g. using login.checkingLogin).
    const [loadState, setLoadState] = useAutoLoad((json) => {
        // On load success
        
        // console.log("Logged in username: " + json.username);

        setLoginStatesFromJson(json, login);

        onLoginStatusChanged(json);

        login.setCheckingLogin(false);
        // setLoadState(LoadState.LOADING); // For testing
    }, (scheduled, init, responseStatus) => {
        // On load error

        if(responseStatus === 401) {
            // console.log("ERROR: " + error);

            console.log("NOT Logged in!");

            resetLoginStates(login);
            onLoginStatusChanged(null);
        }

        login.setCheckingLogin(false);
    }, (scheduled, init) => {
        // On before load
        
        // Only check the login if logged in or initially
        if(loggedInRef.current || init) {
            return management ? "/user/management/verify_login" : "/user/verify_login";
        }
        else {
            return null;
        }

    }, [checkLoginTriggerInternal], true, false, false, false, true);


    // RENDER:

    return (
        loadState === LoadState.LOADING ?
            null // <Loading fixed={true} management={management} />  // Render all child Routes
            /* <div>Loading...</div> */ // Avoid the UI to disappear (flickering and also e.g. problematic because the menu closes)
        :
            <Outlet />  // Render all child Routes 
    )
};

export default LoginCheck
